var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoupeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.466,
    height: 35.466
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6 30.421l-7.5-7.5a14.806 14.806 0 10-4.181 4.179l7.5 7.5a2.956 2.956 0 004.181-4.179zM4.433 14.778a10.344 10.344 0 1110.345 10.344A10.356 10.356 0 014.433 14.778z",
    fill: "currentColor"
  })));
}

export default SvgLoupeinline;